export default {
    Men:'Men',
    Women:'Women'
}


// WEBPACK FOOTER //
// ./src/utils/gender.js